import React from 'react';
import { SidebarItem } from '../graphql/generated/graphqlTypes';
import appIcon from '../icons/prefilled/app.svg';
import getExternalIcon from '../post/getExternalIcon';
import { externalDisplayName } from '../utils/post/externalPost';
import SidebarNavItem from './SidebarNavItem';
import SidebarSection from './SidebarSection';
import useExternalPostPlatforms from './useExternalPostPlatforms';
import useSidebarSettings from './useSidebarSettings';

const ExternalPostsNav = () => {
  const platforms = useExternalPostPlatforms();
  const { hiddenItems } = useSidebarSettings();

  if (platforms.length === 0) {
    return null;
  }

  return (
    <SidebarSection
      name="apps"
      icon={appIcon}
      title="Integrations"
      hidden={hiddenItems.has(SidebarItem.Apps)}
    >
      {platforms.map(
        ({ id }) =>
          id && (
            <SidebarNavItem
              key={id}
              to={`/integration-posts/${id}`}
              icon={getExternalIcon(id)}
              subItem
            >
              {externalDisplayName(id)}
            </SidebarNavItem>
          ),
      )}
    </SidebarSection>
  );
};

export default ExternalPostsNav;
